import React, { useState } from "react"
import PropTypes from "prop-types"
import { useForm, FormProvider } from "react-hook-form"
import { useDispatch, useSelector } from "react-redux"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormFeedback, Row, Col } from "reactstrap"
//************************************//
import { trans } from "@utils"
import { ButtonSpinner } from "@src/components"
import CommonInputs from "./CommonInputs"
import { CustomFieldTypes } from "../../../assets/data/constants"
//************************************//

const TypesModal = props => {
  //************************************//
  const { children, dataState } = props
  const { entityCustomFieldItem, customFieldsState } = dataState
  const { customFields, setCustomFields } = customFieldsState
  //************************************//
  const loading = useSelector(state => state.app.loading)
  const dispatch = useDispatch()
  //************************************//
  const [open, setOpen] = useState(true)
  //************************************//
  const formMethods = useForm()
  const { errors, register, unregister, handleSubmit, trigger, getValues, setValue, control } = formMethods
  //************************************//
  const _close = (isSubmitted = false) => {
    setCustomFields(prevState => {
      let entityCustomFieldsList = _.cloneDeep(prevState.entityCustomFieldsList)
      if (isSubmitted !== true && prevState.editItemModal.isNew) {
        entityCustomFieldsList = _.filter(entityCustomFieldsList, x => x.key !== prevState?.editItemModal?.data?.key)
      }
      return {
        ...prevState,
        entityCustomFieldsList,
        editItemModal: {}
      }
    })
    // props.onClose()
  }
  //************************************//
  const onSubmit = async (data) => {
    const checkErr = await trigger()
    if (!checkErr) {
      return
    }
    setCustomFields(prevState => {
      _.find(prevState.entityCustomFieldsList, x => x.key === entityCustomFieldItem.key).name = data.name
      _.find(prevState.entityCustomFieldsList, x => x.key === entityCustomFieldItem.key).description = data.description
      _.find(prevState.entityCustomFieldsList, x => x.key === entityCustomFieldItem.key).is_required = data.is_required
      const config = {}
      if (data?.config?.max_digits) {
        config['max_digits'] = data?.config?.max_digits?.value
      }
      if (data?.config?.decimals) {
        config['decimals'] = data?.config?.decimals?.value
      }
      if (entityCustomFieldItem.field_type === 'email') {
        config['is_notification_recipient'] = !!_.get(data, 'config.is_notification_recipient', false)
      }
      _.find(prevState.entityCustomFieldsList, x => x.key === entityCustomFieldItem.key).config = config
      return {
        ...prevState,
        refresh: !prevState.refresh
      }
    })
    _close(true)
  }
  //************************************//
  return (
    <Modal
      scrollable={false}
      isOpen={true}
      toggle={_close}
      unmountOnClose={true}
      backdrop={true}
      className='modal-lg'
      modalClassName={''}
    >
      <FormProvider {...formMethods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader toggle={_close}>
            {CustomFieldTypes[entityCustomFieldItem.field_type]
              ? trans(CustomFieldTypes[entityCustomFieldItem.field_type].label)
              : entityCustomFieldItem.field_type}
          </ModalHeader>
          <ModalBody>
            <CommonInputs data={entityCustomFieldItem} key={1} />
            {children}
          </ModalBody>
          <ModalFooter>
            <Button color={'flat-secondary'} type='button' onClick={_close}>
              {trans('gen.actions.cancel')}
            </Button>
            <Button color={'primary'} type='submit' disabled={loading}>
              {loading && <ButtonSpinner />}
              {trans('gen.actions.save')}
            </Button>
          </ModalFooter>
        </Form>
      </FormProvider>
    </Modal>
  )
}

TypesModal.propTypes = {

}

export default TypesModal